import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { FormGroup } from '@material-ui/core';
import CheckboxItem from './CheckBoxItem';
import './CheckBoxGroup.scss';
import { scrollToTop } from '../../../utils/smartutils';

const CheckboxGroup = (props) => {
  const { parents, onItemClickHandler, indeterminate, meta } = props;

  function itemClickHandler(clickedItem, isChecked) {
    onItemClickHandler(clickedItem, isChecked);
  }

  return (
    <div className="checkbox-wrapper">
      <FormGroup>
        {meta.touched && meta.error && (
          <span className="form__form-group-error">
            {meta.error}
            {scrollToTop()}
          </span>
        )}
        {parents.map((father) => (
          <div className="checkbox-head" key={uuid()}>
            <CheckboxItem
              key={father.featureId}
              label={father.featureName}
              value={father.featureId}
              checked={father.hasAcess}
              indeterminate={indeterminate}
              checkboxChangeCallback={(checkStatus) =>
                itemClickHandler(father, checkStatus)
              }
            />

            {father.childrens
              ? father.childrens.map((child) => (
                  <div className="checkbox-children" key={uuid()}>
                    <CheckboxItem
                      label={child.featureName}
                      value={child.featureId}
                      checked={child.hasAcess}
                      checkboxChangeCallback={(checkStatus) =>
                        itemClickHandler(child, checkStatus)
                      }
                    />
                  </div>
                ))
              : null}
          </div>
        ))}
      </FormGroup>
    </div>
  );
};

export default CheckboxGroup;

CheckboxGroup.propTypes = {
  parents: PropTypes.arrayOf(PropTypes.shape).isRequired,
  onItemClickHandler: PropTypes.func.isRequired,
  indeterminate: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

CheckboxGroup.defaultProps = {
  indeterminate: false,
  meta: null,
};
